// ANCHOR
tetloose.anchor = function () {
    var $scrollTrigger = $('[rel=js-anchor]');

    if ($scrollTrigger.length) {
        $scrollTrigger.on('click', function(e) {
            e.preventDefault();
            var $t = $(this),
                $tData = $t.data('location'),
                $location;

            $location = $($tData);

            if ($tData === 'html') {
                $('html, body').animate({
                    scrollTop: $location.offset().top
                }, 1000);

                return false;

            } else {
                $('html, body').animate({
                    scrollTop: $location.offset().top - $mastHead.outerHeight()
                }, 1000);

                return false;
            }
        });
    }

    // IF PAGE LOADS AND FINDS AN ANCHORE IN THE URL
    if (location.hash){
        var $locationAnchor = $(location.hash);
        $('html, body').scrollTop(0);
        $('html, body').animate({
            scrollTop: $locationAnchor.offset().top - $mastHead.outerHeight()
        }, 1500);
    }
};
